export default __webpack_public_path__ + "static/media/howtouse_plus_05_01_en.7903b391.png";